export default "__VITE_ASSET__DzXVBILf__"